import { c as _c } from "react/compiler-runtime";
import { m } from 'framer-motion';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import { varTap, varHover, transitionTap } from 'src/components/animate';

// ----------------------------------------------------------------------

export function AccountButton(t0) {
  const $ = _c(21);
  let displayName;
  let other;
  let photoURL;
  let sx;
  if ($[0] !== t0) {
    ({
      photoURL,
      displayName,
      sx,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = displayName;
    $[2] = other;
    $[3] = photoURL;
    $[4] = sx;
  } else {
    displayName = $[1];
    other = $[2];
    photoURL = $[3];
    sx = $[4];
  }
  let t1;
  let t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = varTap(0.96);
    t2 = varHover(1.05);
    t3 = transitionTap();
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      p: {
        md: 0
      },
      width: {
        xs: 48,
        md: 40
      },
      height: {
        xs: 48,
        md: 40
      }
    };
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== sx) {
    t5 = Array.isArray(sx) ? sx : [sx];
    $[9] = sx;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = [t4, ...t5];
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      width: 32,
      height: 32
    };
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== displayName || $[15] !== photoURL) {
    t8 = <Avatar src={photoURL} alt={displayName} sx={t7} />;
    $[14] = displayName;
    $[15] = photoURL;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== other || $[18] !== t6 || $[19] !== t8) {
    t9 = <IconButton component={m.button} whileTap={t1} whileHover={t2} transition={t3} aria-label="Account button" sx={t6} {...other}>{t8}</IconButton>;
    $[17] = other;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}